<template>
  <div class="reject">
    <el-dialog
      :label="$t('cooperation.label.sureAuditReason')"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
    >
      <div class="result">
        <el-form :model="topData" :rules="rules" ref="topData" label-width="100px">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="原因" prop="auditReason">
                <el-input
                  :placeholder="$t('cooperation.placeholder.auditReason')"
                  v-model="topData.auditReason"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cooperation.buttons.cancel') }}</el-button>
        <el-button type="primary" @click="handleSure">{{
          $t('cooperation.buttons.sure')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'check',
    data() {
      return {
        dialogVisible: false,
        topData: {
          auditReason: null,
        },
        rules: {
          auditReason: [
            {
              required: true,
              message: this.$t('cooperation.placeholder.auditReason'),
              trigger: ['blur', 'change'],
            },
          ],
        },
        type: null,
      };
    },
    methods: {
      // type 2-驳回，1-审批
      openDialog(typeCode, type) {
        this.type = type;
        if (typeCode == 'ZT03') {
          this.topData.auditReason = '通过';
        } else if (typeCode == 'ZT05') {
          this.topData.auditReason = '不通过';
        } else {
          this.topData.auditReason = '';
        }
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.topData.clearValidate();
        });
      },
      handleClose() {
        this.dialogVisible = false;
      },
      handleSure() {
        this.$refs['topData'].validate((valid) => {
          if (valid) {
            this.dialogVisible = false;
            this.$emit('handleSure', this.topData.auditReason, this.type);
          }
        });
      },
    },
  };
</script>

<style scoped></style>
